$ = require 'jquery'
Elements = require '../elements'
{ map } = require 'lodash'

module.exports =
class serviceSequence

  constructor: ->
    @$window   = Elements.$window
    @$section  = $ '.section-service'
    @$heading  = @$section.find '.heading'
    @$list     = @$section.find '.service-list li'
    @$img      = @$list.find '.image'
    @$frame    = @$list.find '.frame'
    @$thumb    = @$list.find '.thumb'
    @$text     = @$list.find '.text'

  getInitialVals: =>
    [
      {
        e: [ @$heading ]
        p: { display: 'none' }
      }
      {
        e: [ @$list, @$thumb, @$text ]
        p: { visibility: 'hidden' }
      }
    ]

  getSequences: =>
    listSequences = map @$list, (el, i) =>
      [
        {
          e: @$list.eq i
          p: { translateY: [ 0, 100 ] }
          o: { duration: 300, easing: 'easeOutSine', visibility: 'visible', delay: 300 + (200 * i) }
        }
        {
          e: @$thumb.eq i
          p: { translateY: [ 0, -200 ] }
          o: { duration: 300, easing: 'easeOutSine', visibility: 'visible', delay: 200 }
        }
        {
          e: @$text.eq i
          p: { translateY: [ 0, -10 ] }
          o: { duration: 100, easing: 'easeOutSine', visibility: 'visible' }
        }
        {
          e: @$img.eq i
          p: { translateY: 18 }
          o: { duration: 100, visibility: 'visible', sequenceQueue: false }
        }
        {
          e: @$img.eq i
          p: { translateY: 0 }
          o: { duration: 100, visibility: 'visible' }
        }
      ]

    {
      title: [
        {
          e: @$heading
          p:
            opacity   : [ 1, 0 ]
            translateX: [ 0, 'easeOutSine', -200 ]
          o: { duration: 300, display: 'block' }
        }
      ]
      list1: listSequences[0]
      list2: listSequences[1]
      list3: listSequences[2]
    }



// WEBPACK FOOTER //
// ./webpack/requires/pc/views/anime-sequence/service-sequence.coffee